import * as api from './index';
const t = '/projects';

export default {
  get: api.get(t),
  create: api.post(t),
  update: api.put(`${t}/:id`),
  remove: api.del(`${t}/:id`),
};